import { render, staticRenderFns } from "./invoice-mailing.vue?vue&type=template&id=c803fa36&"
import script from "./invoice-mailing.vue?vue&type=script&lang=js&"
export * from "./invoice-mailing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports